module.exports = __webpack_public_path__ + "img/fa04.221534a0.jpg";